var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_382_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.64642 1.47975C8.76334 0.0076042 10.3161 0.000427246 10.3161 0.000427246C10.3161 0.000427246 10.5471 1.38449 9.43751 2.71778C8.25272 4.14145 6.90604 3.90849 6.90604 3.90849C6.90604 3.90849 6.65317 2.78883 7.64642 1.47975V1.47975ZM7.0481 4.87802C7.62271 4.87802 8.68914 4.08816 10.0773 4.08816C12.4667 4.08816 13.4067 5.78838 13.4067 5.78838C13.4067 5.78838 11.5682 6.72833 11.5682 9.0091C11.5682 11.582 13.8584 12.4687 13.8584 12.4687C13.8584 12.4687 12.2575 16.9747 10.0951 16.9747C9.10186 16.9747 8.32971 16.3054 7.28324 16.3054C6.2168 16.3054 5.15852 16.9997 4.46925 16.9997C2.49463 16.9998 0 12.7253 0 9.28936C0 5.90888 2.11154 4.13553 4.09208 4.13553C5.37961 4.13553 6.37874 4.87802 7.0481 4.87802V4.87802Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_382_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8584,
    height: 17,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleMusic);
export default __webpack_public_path__ + "static/media/appleMusic.afd05dd2.svg";
export { ForwardRef as ReactComponent };